/**
 * Coerce Algolia/Dynamo boolean fields that may arrive as bool or string.
 * String values are matched case-insensitively: the Companies table stores company flags such
 * as isRecruitmentCompany as 'TRUE'/'FALSE', and the indexer copies them onto jobs unchanged.
 */
export function coerceTypesenseBoolField(value: unknown): boolean | undefined {
  if (typeof value === 'boolean') return value;
  if (typeof value !== 'string') return undefined;
  const normalized = value.trim().toLowerCase();
  if (normalized === 'true') return true;
  if (normalized === 'false') return false;
  return undefined;
}
